import { render, staticRenderFns } from "./searchCounter.vue?vue&type=template&id=20ba717c&scoped=true&"
import script from "./searchCounter.vue?vue&type=script&lang=js&"
export * from "./searchCounter.vue?vue&type=script&lang=js&"
import style0 from "./searchCounter.vue?vue&type=style&index=0&id=20ba717c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ba717c",
  null
  
)

export default component.exports